module.exports = __webpack_public_path__ + "img/top_left_corner_ribbon.ac369421.png";